'use strict';

const alertMessage = require('../utils/alertMessage');
const minicartPanel = require('../utils/minicartPanel');
const csrf = require('cisalfa/csrf/csrf');

const SELECTORS = {
    element: '.js-add-sub-to-cart',
    dataset: '#js-page-dataset',
    quantity: '.js-minicart-qty',
    quantityLabel: '.js-minicart-qty-label',
    currentPage: '.js-page',
    link: '.js-minicart-link',
};

const CLASSES = {
    alertDanger: 'cc-alert--danger',
    alertSuccess: 'cc-alert--success',
}

/**
 * AddSubscription component that adds subscription into cart
 */
class AddSubscription {
    constructor(element) {
        this.element = element;
        this.action = $(SELECTORS.dataset).data('addSubscription');
        this.quantity = $(SELECTORS.quantity);
        this.quantityLabel = $(SELECTORS.quantityLabel);
        this.currentPage = $(SELECTORS.currentPage);
        this.link = $(SELECTORS.link);
        this.initEvents();
    }

    initEvents() {
        $('body').off('click', '.js-add-sub-to-cart').on('click', '.js-add-sub-to-cart', async (e) => {

            e.preventDefault();
            e.stopPropagation();

            if(!this.action){
                return;
            }

            $.spinner().start();

            let csrf_token = await csrf.methods.getCsrfToken();

            $.ajax({
                url: this.action,
                method: 'POST',
                data: { csrf_token: csrf_token.token },
                success: (data) => {
                    
                    if(data.error){
                        $.spinner().stop();

                        if(data.isDanger){
                            alertMessage(data.message, CLASSES.alertDanger);
                        } else{
                            alertMessage(data.message, CLASSES.alertSuccess);
                        }
                        return;
                    }

                    if (this.currentPage && this.currentPage.data('action') == 'Cart-Show') {
                        window.location.reload();
                    } else {
                        $('body').trigger('product:afterAddToCart');
                        this.quantity.css('display', () => data.quantityTotal === 0 ? 'none' : 'inline-flex');
                        this.quantity.text(data.quantityTotal);
                        if (data.quantityTotal === 1) {
                            this.quantityLabel.addClass('cc-single').removeClass('cc-multiple');
                        } else {
                            this.quantityLabel.addClass('cc-multiple').removeClass('cc-single');
                        }
                        this.link.attr({
                            'aria-label': data.minicartCountOfItems,
                            title: data.minicartCountOfItems
                        });
                        $.spinner().stop();
                        if (minicartPanel.isEnabled()) {
                            // Confirmed by the minicart panel, with the subscription on top
                            $('body').trigger('minicart:show', {
                                added: true,
                                pliUUID: data.pliUUID,
                                fallbackMessage: data.message
                            });
                        } else {
                            alertMessage(data.message, CLASSES.alertSuccess);
                        }
                    }
                },
                error: (err) => {
                    console.error(err);
                    $.spinner().stop();
                }
            });
        });
    }

}

module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        new AddSubscription($(element));
    });
};
